export abstract class Adjustment {
    id: number | string;
    price: number;
    adjustment: number;
    constructor(id: number | string, price: number, adjustment: number) {
        this.id = id;
        this.price = price;
        this.adjustment = adjustment;
    }

    abstract clone();
}

export class ItemAdjustments extends Adjustment {
    quantity: number;
    invalidExpired: boolean;
    applicable: boolean; // indicates there's a modifier applicable to the corresponding Catalogue item Id(id)

    constructor(id: number | string, price: number, adjustment: number, quantity: number, invalidExpired: boolean) {
        super(id, price, adjustment);
        this.quantity = quantity;
        this.invalidExpired = invalidExpired;
        this.applicable = false;
    }

    public clone(): ItemAdjustments {
        const clone = new ItemAdjustments(this.id, this.price, this.adjustment, this.quantity, this.invalidExpired);
        clone.applicable = this.applicable;
        return clone;
    }
}

export class GroupAdjustments extends Adjustment {
    items: ItemAdjustments[] = [];

    public clone(): GroupAdjustments {
        const clone = new GroupAdjustments(this.id, this.price, this.adjustment);
        clone.items = this.items.map(t => t.clone());
        return clone;
    }
}

export class CartAdjustments extends Adjustment {
    groups: GroupAdjustments[] = [];

    clone(): CartAdjustments {
        const clone = new CartAdjustments(this.id, this.price, this.adjustment);
        clone.groups = this.groups.map(t => t.clone());
        return clone;
    }
}
